var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPinFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 1a1 1 0 0 0 1 1v3.764a1 1 0 0 1-.106.447L3.106 9.79a1 1 0 0 0-.106.447V11a1 1 0 0 0 1 1h4v5a1 1 0 1 0 2 0v-5h4a1 1 0 0 0 1-1v-.764a1 1 0 0 0-.106-.447L13.106 6.21A1 1 0 0 1 13 5.764V2a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1Z",
  clipRule: "evenodd"
})));
export default SvgIconPinFilled;